import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { getFetchConfig } from '../Base/modelManager'

import { Button, Col, Row } from 'react-bootstrap'
import { message } from 'antd'


class CalculTicpe extends React.Component {
    constructor(props) {
        super(props)




        this.state = {
        //    annees: [],
            periodes: [],
            selectedAnnee: undefined,
            periodeTypes: undefined,
            periodeValue: undefined,
            selectedPeriodicite: undefined,
            selectedPeriodiciteValue: undefined,
            typeTransport: undefined
        }
        
    }

    onExcelImport = (e) => {
        const hide = message.info('Traitement en Cours..', 0);
        const sender = e.target
        sender.disabled = true;

        const url = this.props.apiUrl +'/Services/TippExport?annee='+this.props.selectedAnnee+'&periodicite='+this.props.selectedPeriodicite+ '&periode='+this.props.selectedPeriodiciteValue + '&typeTransport='+this.props.typeTransport
        const request = {
            method: 'GET',
            token: this.props.JWTToken
        }


        return fetch(url, getFetchConfig(request))
            .then(response => {
                response.blob()
                    .then(blob => {
                        setTimeout(hide, 0)
                        message.success('Enregistrement effectué', 3)
                        sender.disabled = false;
                        let url = window.URL.createObjectURL(blob);
                        // window.open(url)
                        let a = document.createElement('a');
                        a.href = url;
                        a.download = 'tipce.xlsx'
                        a.click();
                    }).catch(error => {
                        setTimeout(hide, 0)
                        sender.disabled = false;
                        message.error(error)
                    })
            })
            .catch(error => {
                setTimeout(hide, 0)
                message.error(error)
            })

    }


    componentDidMount() {
     /*   const request = {
            endPoint: this.props.apiUrl + '/Services/anneesTicpe',
            methode: 'GET',
            token: this.props.JWTToken
        }

        fetchServer(request,
            json => {
                this.setState({ annees: json.value })
            },
            error => message.error(error))*/
    }


    componentDidUpdate(prevProp) {
        if (prevProp.currentClient !== this.props.currentClient)
            this.handleFetch()
    }




    onError = (error) => {
        message.error(error)
    }

    ticpeTaxi=()=>{
        return (
            <div className='TIcpeResult' >

            <Row className='ticpeInfo'>
                Récapitulatif des Volumes par Type de carburant et région
            </Row>
            <Row style={{ textAlign: 'center' }}>
                <Col span={5}>Carburant</Col>
                <Col span={5}>Region</Col>
                <Col span={5}>Nombre de litres </Col>
                <Col span={4}>Taux de remboursement(en €/hl) [b]</Col>
                <Col span={5}>Montant du remboursement&#42; <br /> ([a]x[b])/100</Col>
            </Row>
            {this.props.data.map(item => {
                return (
                    <Row style={{ textAlign: 'center' }}>
                        <Col span={5}>{item.Carburant}</Col>
                        <Col span={5}>{item.region}</Col>
                        <Col span={5}>{item.volume}</Col>
                        <Col span={4}>{item.taux}</Col>
                        <Col span={5}>{item.montant}</Col>
                    </Row>
                )
            })
            }

            <Row className='ticpeInfo'>
                <Col span={8} className="col-sm-4">
                    <Button className='TicpeSend' onClick={this.onExcelImport }>Telecharger le Détail au format Excel&#42;</Button>
                </Col>
                <Col span={16}>
                    <span>&#42;: Les données indiquées sont calculées sur la totalité de vos consommations de gazole<br />
                        Elles ne peuvent pas être transmises en l'état aux services douaniers.<br />
                        Veuillez-vous assurer de l'éligibilité de vos véhicules pris en compte dans le calcul. Plus d'informations disponibles  <a href="https://www.service-public.fr/professionnels-entreprises/vosdroits/F31222" rel="noreferrer" target="_blank"> ICI </a><br />
                        En aucun cas, la responsabilité {this.props.url==='btf' ? 'du Groupe BTF' : 'd\'Autogestion'} ne pourrait être engagée en cas de déclaration erronée résultant de l'utilisation de ces données </span>
                </Col>
            </Row>

        </div>
        )
    }

    ticpeStd=()=>{
        return (
            <div className='TIcpeResult' >

            <Row className='ticpeInfo'>
                TAUX RÉGIONAUX(3) : Nombre de litres pour lequel le remboursement est demandé, détaillé par région d'achat, et par montant du remboursement correspondant :
            </Row>
            <Row style={{ textAlign: 'center' }}>
                <Col span={6}></Col>
                <Col span={6}>Nombre de litres de gazole acquis en France sans décimale [a]</Col>
                <Col span={6}>Taux de remboursement(en €/hl) [b]</Col>
                <Col span={6}>Montant du remboursement&#42; <br /> ([a]x[b])/100</Col>
            </Row>
            {this.props.data.filter(item => item.region !== '*').map(item => {
                return (
                    <Row style={{ textAlign: 'center' }}>
                        <Col span={6} >{item.region}</Col>
                        <Col span={6}>{item.volume}</Col>
                        <Col span={6}>{item.taux}</Col>
                        <Col span={6}>{item.montant}</Col>
                    </Row>
                )
            })}


            <Row className='ticpeInfo'>
                TAUX FORFAITAIRE(4), uniquement pour les entreprises qui ont acheté du gazole dans au moins trois régions différentes :
            </Row>
            <Row style={{ textAlign: 'center' }}>
                <Col span={6}></Col>
                <Col span={6}>Nombre de litres de gazole acquis en France sans décimale [a]</Col>
                <Col span={6}>Taux de remboursement(en €/hl) [b]</Col>
                <Col span={6}>Montant du remboursement&#42; <br /> ([a]x[b])/100</Col>
            </Row>
            {this.props.data.filter(item => item.region === '*').map(item => {
                return (
                    <Row style={{ textAlign: 'center' }}>
                        <Col span={6}>Total</Col>
                        <Col span={6}>{item.volume}</Col>
                        <Col span={6}>{item.taux}</Col>
                        <Col span={6}>{item.montant}</Col>
                    </Row>
                )
            })
            }

            <Row className='ticpeInfo'>
                <Col span={8} className="col-sm-4">
                    <Button className='TicpeSend' onClick={this.onExcelImport }>Telecharger le Détail au format Excel&#42;</Button>
                </Col>
                <Col span={16}>
                    <span>&#42;: Les données indiquées sont calculées sur la totalité de vos consommations de gazole<br />
                        Elles ne peuvent pas être transmises en l'état aux services douaniers.<br />
                        Veuillez-vous assurer de l'éligibilité de vos véhicules pris en compte dans le calcul. Plus d'informations disponibles  <a href="https://www.service-public.fr/professionnels-entreprises/vosdroits/F31222" rel="noreferrer" target="_blank"> ICI </a><br />
                        En aucun cas, la responsabilité d\'Autogestion' ne pourrait être engagée en cas de déclaration erronée résultant de l'utilisation de ces données </span>
                </Col>
            </Row>

        </div>
        )
    }



    render() {
        if (this.props.data.length === 0)
            return (<Row>
                Aucune transactions sur la periode données
            </Row>)

        return  this.props.typeTransport==='T'? this.ticpeTaxi() : this.ticpeStd()

        

    }
}


const mapStateToProps = (state) => {
    return ({
        serverConfigLoaded: state.server.initialized,
        clients: state.authentication.clients,
        currentClient: state.authentication.currentClient,
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
        url : state.server.url,
    })
}

CalculTicpe.propTypes = {
    dispatch: PropTypes.func,
    apiUrl: PropTypes.string,
    clients: PropTypes.array,
    currentClient: PropTypes.object,
    JWTToken: PropTypes.string,
    data: PropTypes.array
};

export default connect(mapStateToProps)(CalculTicpe);
